import { render } from "./navigationFlyoutTeaser.vue?vue&type=template&id=d047f4b8&ts=true"
import script from "./navigationFlyoutTeaser.vue?vue&type=script&lang=ts"
export * from "./navigationFlyoutTeaser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__